import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_transfering_current_status = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const canView  = hasPermission("Transfering status", "view");
      


  useEffect(() => {
    setLoading(true);
    axios.get(`https://rfs2.infraconsoft.net.in/api/vehicle_transfering_current_status`)
      .then((response) => {
        setData(response.data.vehicleCurrentStatus);
        setFilteredData(response.data.vehicleCurrentStatus);
      })
      .catch((error) => {
        console.error("Error fetching vehicleCurrentStatus:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate pagination indexes
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.fld_vehiclecode && item.fld_vehiclecode.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_transfer_from && item.fld_transfer_from.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_transfer_to && item.fld_transfer_to.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); 
  };  

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Vehicle Transfer-Current status
          </h2>
          <div>
            <Time />
          </div>
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Vehicle Code"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
              <th>Vehicle Code</th>
                <th>Transfer From</th>
                <th>Status</th>
                <th>Transfer To</th> 
                <th>Transfer By</th>
                <th>Approved by  </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.fld_vehiclecode}</td>
                    <td>{item.fld_transfer_from}</td>
                    <td>Transfering</td>
                    <td>{item.fld_transfer_to}</td>
                    <td>{item.fld_transfer_by}</td>
                    <td>{item.fld_approval_by}</td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
<div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_transfering_current_status;
